<template>
    <div class="page white_bg">
        <div class="absolutePosition w100p" style="z-index: 1; height: 278px; left:0; top: 0;
            background: linear-gradient(125deg, #191818 0%, #646464 54%, #272727 100%);">
        </div>

        <div class="relative" style="z-index: 2; height: 46px;"><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon white floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="main relative" style="z-index: 2;">

            <!-- VIP 选项 tab -->
            <div class="flexLayout vipTabHeader centered marginT8" :data-activevip="activeVipType ? activeVipType.type : ''">
                <div class="flexItem tabItem" :class="{'active' : activeVipType == vipTypeItem}"
                     v-for="(vipTypeItem, index) in vipTypeList" :key="index"
                     @click="changeTab(vipTypeItem)" v-show="inArray(vipTypeItem.code, [3])">
                    {{vipTypeItem.title}}
                </div>
            </div>

            <div class="user_card marginT20 centered" style="max-width: 339px;">
                <div class="user_message flexLayout">
                    <div class="circle" style="width:56px;height:56px;border:2px solid #fff;box-sizing:border-box;">
                        <a class="block fullSpace" href="javascript:;">
                            <img class="cover fullSpace circle user_photo"
                                 :src="userData ? userData.headerImg : 'shixun_logo.png'" alt="">
                        </a>
                    </div>
                    <div class="flexItem user_param">
                        <div class="user_name font18r white">
                            <span>{{userData ? userData.userName : '未登录'}}</span>
                        </div>
                        <div class="user_invite" v-if="userData">
                            <div class="mrAndfont copyAction white f10" :data-clipboard-text="userData ? userData.introduceCode : ''">
                                <span>账号: {{userData ? userData.introduceCode : ''}}</span>
                                <img style="margin-left:4px;width:8px;height:8px;" src="icon/userIcon/copy_icon.png" alt="复制图标">
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- end .user_card -->

            <!-- VIP 卡 -->
            <div class="generalPagePaddingH marginT16">

                <div class="vipCard">

                    <!-- 资料 VIP 卡 -->
                    <div v-show="activeVipTypeIndex == 0">

                        <!-- 完全未开通过状态 -->
                        <img class="bg limit_max_width block centered" src="vip/vip_card_datum.png" width="339" height="100"
                             v-if="!userInstance || userInstance.getVipInfo()['datum']['neverOpen']"/>

                        <!-- 开通过但已过期状态 -->
                        <img class="bg limit_max_width block centered" src="vip/vip_card_datum_active_gone.png" width="339" height="auto"
                             v-else-if="!userInstance.getVipInfo()['datum']['status']" @click="renewal()"/>

                        <!-- 已开通状态但快过期 -->
                        <img class="bg limit_max_width block centered" src="vip/vip_card_datum_active_going.png" width="339" height="auto"
                             v-else-if="userInstance.getVipInfo()['datum']['expiring'] <= 30" @click="renewal()"/>

                        <!-- 已开通状态 -->
                        <template v-else>
                            <div class="wFit center">

                                <!-- 已开通状态且远远没到过期 -->
                                <img class="bg limit_max_width block centered" src="vip/vip_card_datum_active.png" width="339" height="auto"
                                     data-v-else @click="renewal()"/>

                                <!-- 已开通状态 -->
                                <div class="termOfValidity" @click="renewal()">
                                    已开通 | 有效期至：{{userInstance.getVipInfo()['datum']['dueTime'].substr(0, 10)}}
                                </div>
                            </div>
                        </template>

                    </div>

                </div><!-- end .vipCard -->

            </div>
            <!-- End VIP 卡 -->

            <van-tabs v-model="tabModule.activeIndex" sticky swipeable
                      title-inactive-color="#101010" title-active-color="#F28500"
                      line-width="0" line-height="0" style="border-top: solid 1px #BBB;">
                <van-tab title="详情">

                    <div class="tabContent bgEEE">

                        <datumVip v-if="activeVipTypeIndex==0" :userInstance="userInstance"
                                  :agreeServiceProtocol="agreeServiceProtocol"
                                  :details="vipDetails[activeVipType.type]"
                                  :vipPrice="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type)['price'] : '???'"
                                  :originalPrice="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type)['originalPrice'] : '???'"
                                  @changeAgreeServiceProtocol="changeAgreeServiceProtocol"/>

                    </div>

                </van-tab>

                <van-tab title="会员指南">
                    <article class="paddingH8">
                        <div class="content" v-html="vipEnjoyData && typeof(vipEnjoyData.fingerpost) !== 'undefined' ?
                            vipEnjoyData.fingerpost[0].content : ''"></div>
                    </article>
                </van-tab>

                <van-tab title="专属客服">
                    <article class="paddingH8">
                        <div class="content" v-html="vipEnjoyData && typeof(vipEnjoyData.service) !== 'undefined' ?
                        vipEnjoyData.service[0].content : ''"></div>
                    </article>
                </van-tab>

            </van-tabs>

            <vipRenewalDrawer ref="vipRenewalDrawer" type="payVip" :vipType="activeVipType"
              :productData="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type) : null"
              :isAgreeServiceProtocol="agreeServiceProtocol"
              :onPaySuccess="onPaySuccess"
              @changeAgreeServiceProtocol="changeAgreeServiceProtocol"/>

            <vipPayDetailDrawer ref="vipPayDetailDrawer" :productData="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type) : null"
                @open="$refs.operationArea.showDetail = true" @close="$refs.operationArea.showDetail = false"
                :highlightColor="activeVipType && activeVipType.type === 'datum' ? 'red' : 'yellow'"/>

            <!-- 底部开通操作栏 (从来没开通过才显示) -->
            <div style="height: 86px; margin-top: 42px;" v-show="isShowOperationArea()">
                <operationArea ref="operationArea" :vipType="activeVipType" type="payVip" :isAgreeServiceProtocol="agreeServiceProtocol"
                   :vipPrice="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type)['price'] : '???'"
                   :dbValue="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type)['dbValue'] : '???'"
                   :originalPrice="getVipPurchaseYearPackage(activeVipType.type) ? getVipPurchaseYearPackage(activeVipType.type)['originalPrice'] : '???'"
                   :onPaySuccess="onPaySuccess"
                   :userInstance="userInstance"
                   @showDetail="$refs.vipPayDetailDrawer.open()"
                    @hideDetail="$refs.vipPayDetailDrawer.close()"
                />

            </div>

        </div>

        <distributeButton ref="distributeButton" orderBizType="OPEN_VIP" :id="activeVipId" @sharePoster="sharePoster()"/>

        <shareDrawer ref="shareDrawer" :bizType="bizTypeEnum.VIP.code" :id="shareDrawer.id"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import ClipboardJS from "clipboard";

// config
import appConfig from '../../appConfig';

// api
import vipApi from '@api/vip';

// data
import vipTypeEnum2 from '@data/vipTypeEnum2';
import bizTypeEnum  from "@/data/bizTypeEnum";
import externalApp  from '@data/externalApp';

import VipTypeBroadSenseEnum    from '@/data/VipTypeBroadSenseEnum';

// platformApi
import requestManager   from '@comp/platformApi/requestManager'
import consoleApi       from "@comp/platformApi/consoleApi";

// modules
import courseVip    from './introduction/courseVip'
import datumVip     from './introduction/datumVip'
import atlasVip     from './introduction/atlasVip'
import vipPayDetailDrawer   from '@comp/drawer/vipPayDetailDrawer'
import vipRenewalDrawer     from '@comp/drawer/vipRenewalDrawer'
import operationArea        from './operationArea'
import distributeButton  from '@/components/distribution/distributeButton';
import shareDrawer from "@comp/drawer/shareDrawer";
import {Tab, Tabs}          from 'vant';

// util
import appHelper    from '@/util/appHelper';
import userUtil     from "@comp/shixunApp/userUtil";
import objectHelper from "@/util/objectHelper";
import arrayHelper from "@/util/arrayHelper";
import wechatHelper from "@/util/wechatHelper";
import timerManager from "@comp/platformApi/timerManager";

const config = {
    apiConfig : {
        payVip : {
            url : "portal/order/pay/vip",
            method : 'post'
        },
        list : {
            url : '',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '园长“苦恼”，幼儿园之间到底在竞争什么',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: "vipIndex",
    extends : shixunPagePart,
    components : {
        datumVip,
        vipPayDetailDrawer, vipRenewalDrawer,
        operationArea, distributeButton, shareDrawer,
        'van-tab': Tab,
        'van-tabs': Tabs,
    },
    data () {
        return {
            title : '师讯文库会员',
            apiConfig : config.apiConfig,
            pageKey: 'viptype',
            // pageSize : 8,
            autoLoadData : appConfig.mode != 'demo',
            bizTypeEnum : bizTypeEnum,

            /**
             * @type    Array
             */
            vipTypeList : vipTypeEnum2.getList(),

            /**
             * @type    {Object}
             */
            activeVipType : vipTypeEnum2.getList()[0],

            activeVipTypeIndex : 0,
            activeVipId : '',

            externalApp : externalApp,

            userData : null,
            userInstance : null,

            vipEnjoyData : null,

            tabModule: {
                activeIndex: 0
            },

            operationArea : {
                showDetail : false
            },

            productData : {
                id : '',
                title : 'vip年卡',
                price : 265,
                originalPrice : 999,
                image : ''
            },

            agreeServiceProtocol : false,

            /**
             * @member
             * @type    {Object}
             */
            vipPurchasePackages : (() => {
                let map = {};
                let vipList = vipTypeEnum2.getList();
                for (let i=0; i<vipList.length; i++)
                {
                    map[vipList[i].type] = [];
                }
                return map;
            })(),

            /**
             * @member
             * @type    {Object}
             */
            vipPrivilegeInfo : (() => {
                let map = {};
                let vipList = vipTypeEnum2.getList();
                for (let i=0; i<vipList.length; i++)
                {
                    map[vipList[i].type] = [];
                }
                return map;
            })(),

            /**
             * @member
             * @type {Object}
             */
            vipDetails : (() => {
                let map = {};
                let vipList = vipTypeEnum2.getList();
                for (let i=0; i<vipList.length; i++)
                {
                    map[vipList[i].type] = [];
                }
                return map;
            })(),

            shareDrawer : {
                id : ''
            }

        }
    },
    methods : {
        back : function () {
            appHelper.redirect('/');
        },
        /**
         * @param   {Object}    vipTypeItem
         */
        changeTab(vipTypeItem) {

            const me = this;

            // this.activeVipTypeIndex = vipTypeItem.code;
            this.activeVipType = vipTypeItem;
            this.shareDrawer.id =
            this.activeVipId = this.getVipPurchaseYearPackage(this.activeVipType.type)['dbValue'];
            this.setWechatShare();

            let vipCode = '';
            switch (this.activeVipType.type)
            {
                case 'course_vod' :
                    vipCode = VipTypeBroadSenseEnum.COURSE_VOD.code;
                    break;
                case 'datum' :
                    vipCode = VipTypeBroadSenseEnum.DATUM.code;
                    break;
                case 'atlas_vip' :
                    vipCode = VipTypeBroadSenseEnum.ATLAS.code;
                    break;
            }
            vipApi.loadVipEnjoyInfo(vipCode, (result) => {
                console.log(result);
                me.vipEnjoyData = result.data;
            });
        },
        isShowOperationArea() {

            if (!this.userInstance) // not login
            {
                return true;
            }

            let vipType = this.activeVipType.type;
            if (this.userInstance.getVipInfo()[vipType].status) // 开通状态不显示
            {
                return false;
            }

            if (this.vipPurchasePackages[vipType].length < 1)   // VIP 价格信息未加载完毕
            {
                return false;
            }

            return true
        },
        loadVipInfo() {
            for (let i=0; i<this.vipTypeList.length; i++)
            {
                let vipType = this.vipTypeList[i].type;
                let vipCode = this.vipTypeList[i].code;

                let requestOptions = objectHelper.clone(vipApi.vipInfo);
                requestOptions.params = {
                    vipType : vipCode,
                    ios : false
                };

                requestManager.request(requestOptions, (error, result) => {
                    if (error)
                    {
                        appHelper.showHint(error.toString());
                        return;
                    }

                    // type: Array
                    let data = result.data;
                    this.vipPurchasePackages[vipType] = data;
                });
            }
        },
        loadVipEnjoyInfo() {

            const me = this;
            for (let i=0; i<this.vipTypeList.length; i++)
            {
                let vipType = this.vipTypeList[i].type;
                let vipCode = this.vipTypeList[i].code;

                let requestOptions = objectHelper.clone(vipApi.vipEnjoy);
                requestOptions.params = {
                    vipType : vipCode
                };

                requestManager.request(requestOptions, (error, result) => {
                    if (error)
                    {
                        appHelper.showHint(error.toString());
                        return;
                    }

                    // type: Array
                    let data = result.data.privilege;
                    //
                    me.vipPrivilegeInfo[vipType] = data;
                    me.vipDetails[vipType] = result.data.detail;
                });
            }
        },

        /**
         * @method  getVipPurchaseYearPackage
         * @param   {String}  type
         * @returns {null|Object}
         */
        getVipPurchaseYearPackage(type = 'super') {

            let vipPurchaseYearList = this.vipPurchasePackages[type];
            for (let i=0; i<vipPurchaseYearList.length; i++)
            {
                if (vipPurchaseYearList[i].timeType === 'year')
                {
                    return vipPurchaseYearList[i];
                }
            }

            return null;
        },

        changeAgreeServiceProtocol(event) {
            let status = event.status;
            this.agreeServiceProtocol = status;
        },

        // 续费
        renewal() {
            let yearPackage = this.getVipPurchaseYearPackage(this.activeVipType.type);
            this.$refs.vipRenewalDrawer.setProduct({
                id : yearPackage.dbValue,
                title : yearPackage.title,
                price : yearPackage.price,
                bizType : bizTypeEnum.VIP.code
            });
            this.$refs.vipRenewalDrawer.open();
        },

        onPaySuccess : function (result) {

            let orderId = result.orderId || '';
            appHelper.redirect('/vipOpenSuccess/' + orderId);
        },

        /**
         * @method  setWechatShare
         */
        setWechatShare : function(options = {}) {

            let link = '';
            let vipType = this.activeVipType.type;

            if (!this.userInstance)
            {
                link = appHelper.generateShareUrl('/vip/' + vipType);
            }
            else
            {
                link = appHelper.generateShareUrl('/vip/:vipType/promotion/:promotionCode', {
                    ':vipType' : vipType,
                    ':promotionCode' : this.userInstance.introduceCode
                });
            }

            const wechatShareOptions = {
                title   : appHelper.getTitle(),
                // title   : '师讯' + this.activeVipType.title,
                desc    : this.description,
                link    : link,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);

        },

        sharePoster() {
            if (typeof(this.$refs.shareDrawer) === 'undefined')
            {
                this.share();
                return;
            }

            this.$refs.shareDrawer.init({
                // bizType : bizTypeEnum.VIP.code,
                // id: this.getVipPurchaseYearPackage(this.activeVipType.type)['dbValue']
            });
        },

        inArray(element, array) {
            return arrayHelper.existElement(element, array);
        }
    },
    mounted() {

        const me = this;

        let urlType = this.$route.params.type || '';
        if (urlType === 'course_vod')
        // {
        //     this.activeVipTypeIndex = 2;
        //     this.activeVipType = this.vipTypeList[0];
        // }
        if (urlType === 'datum')
        {
            this.activeVipTypeIndex = 0;
            this.activeVipType = this.vipTypeList[0];
        }
        // else if (urlType === 'atlas_vip')
        // {
        //     this.activeVipTypeIndex = 6;
        //     this.activeVipType = vipTypeEnum2.getList().slice(1)[2];
        // }

        const promotionCode   = this.$route.params.promotionCode || '';

        vipApi.loadVipEnjoyInfo(vipTypeEnum2.DATUM.code, (result) => {
            console.log(result);
            me.vipEnjoyData = result.data;
        });

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userData = result;
                this.userInstance = userUtil.createUser(result);
                this.setWechatShare({
                    params : {
                        promotionCode : result.introduceCode
                    }
                });
            }
            else {
                this.setWechatShare();
            }
        }, {
            promotionCode : promotionCode
        });

        this.loadVipInfo();
        this.loadVipEnjoyInfo();

        // init copy icon
        let copyAction = new ClipboardJS('.copyAction');

        copyAction.on('success', function (e) {
            consoleApi.info('Action:', e.action);
            consoleApi.info('Text:', e.text);
            consoleApi.info('Trigger:', e.trigger);
            appHelper.showHint('复制成功');

            e.clearSelection();
        });

        copyAction.on('error', function (e) {
            consoleApi.error('Action:', e.action);
            consoleApi.error('Trigger:', e.trigger);
            appHelper.showMessage('当前浏览器阻止复制，请长按微信号进行复制。');
        });

        // this.$refs.vipRenewalDrawer.open();
        this.$refs.distributeButton.show();

        // 定时刷新套餐 id 数据
        timerManager.setInterval(() => {
            if (!me.activeVipType) { return; }
            me.shareDrawer.id =
            me.activeVipId =
                me.getVipPurchaseYearPackage(me.activeVipType.type) ?
                me.getVipPurchaseYearPackage(me.activeVipType.type)['dbValue'] :
                '';
        }, 1000);


    }
}
</script>

<style lang="scss" scoped>

.wFit{
    width: fit-content;
}

.vipTabHeader {
    width: 308px;
    height: 32px;
    line-height: 32px;
    background: rgba(0,0,0,.13);
    border-radius: 17px;
    .tabItem {
        text-align: center;
        font-size: 16px;
        color: white;

        &.active {
            background: #FFFFFF;
            border-radius: 17px;
            font-weight: bold;
            color: hsla(36, 100%, 57%, 1);
        }
    }

}

.user_card{
    box-sizing: border-box;
    .user_message{
        width: 100%;
        height: 56px;
    }

    .user_param{
        margin-left: 14px;

        .user_name{
            span{

                height: 28px;
                font-size: 20px;
                font-weight: 500;
                line-height: 28px;
                color: #fff;

            }
        }

        .user_invite{
            // display: flex;
            overflow: hidden;
            .mrAndfont{
                float: left;
                height: 16px;
                padding: 0 11px;
                margin-top: 8px;
                margin-right: 6px;
                background: rgba(0,0,0, 0.19);
                font-weight: 500;
                line-height: 16px;
                color: #FFFFFF;
                border-radius: 10px;
            }

        }
    }


}

.vipCard {
    position: relative;

    .termOfValidity {
        position: relative;
        z-index: 1;
        bottom: 36px;
        left: 16px;
        background: hsla(0, 0%, 3%, .2);
        border-radius: 10px;
        height: 18px;
        line-height: 18px;
        font-size: 10px;
        color: white;
        padding: 0 8px;
        width: fit-content;
    }
}



</style>
